// extracted by mini-css-extract-plugin
export default {"audio_player_head":"fa9e1a","spinner":"bcf8d9"};